export default [
  { name: 'Unknown', value: 'UNKNOWN' },
  { name: 'Single-family housing', value: 'SINGLE_FAMILY_HOUSING' },
  { name: 'Multi-family housing', value: 'MULTI_FAMILY_HOUSING' },
  { name: 'Single/multi-family housing', value: 'SINGLE_MULTI_FAMILY_HOUSING' },
  { name: 'New public housing', value: 'NEW_PUBLIC_HOUSING' },
  { name: 'CMO-backed housing', value: 'CMO_BACKED_HOUSING' },
  { name: 'Senior housing independent living', value: 'SENIOR_HOUSING_INDEPENDENT_LIVING' },
  { name: 'Student housing', value: 'STUDENT_HOUSING' },
  { name: 'Other housing', value: 'OTHER_HOUSING' },
  { name: 'Primary/secondary education', value: 'PRIMARY_SECONDARY_EDUCATION' },
  { name: 'Higher education', value: 'HIGHER_EDUCATION' },
  { name: 'Student loans', value: 'STUDENT_LOANS' },
  { name: 'Libraries or museums', value: 'LIBRARIES_OR_MUSEUMS' },
  { name: 'Private higher education', value: 'PRIVATE_HIGHER_EDUCATION' },
  { name: 'Public higher education', value: 'PUBLIC_HIGHER_EDUCATION' },
  { name: 'Charter school', value: 'CHARTER_SCHOOL' },
  { name: 'Other education', value: 'OTHER_EDUCATION' },
  { name: 'Government/public buildings', value: 'GOVERNMENT_PUBLIC_BUILDINGS' },
  { name: 'Fire station/equipment', value: 'FIRE_STATION_EQUIPMENT' },
  { name: 'Correction facilities/courts', value: 'CORRECTION_FACILITIES_COURTS' },
  { name: 'General purpose/public impt', value: 'GENERAL_PURPOSE_PUBLIC_IMPT' },
  { name: 'Police station/equipment', value: 'POLICE_STATION_EQUIPMENT' },
  { name: 'Redevelopment/land clearance', value: 'REDEVELOPMENT_LAND_CLEARANCE' },
  { name: 'Land preservation', value: 'LAND_PRESERVATION' },
  { name: 'Other public service', value: 'OTHER_PUBLIC_SERVICE' },
  { name: 'Military housing', value: 'MILITARY_HOUSING' },
  { name: 'Public human service provider', value: 'PUBLIC_HUMAN_SERVICE_PROVIDER' },
  { name: 'Mobile Home', value: 'MOBILE_HOME' },
  { name: 'Hospitals', value: 'HOSPITALS' },
  { name: 'Hospital equipment loans', value: 'HOSPITAL_EQUIPMENT_LOANS' },
  { name: 'Lifecare/retirement centers', value: 'LIFECARE_RETIREMENT_CENTERS' },
  { name: 'Nursing homes', value: 'NURSING_HOMES' },
  { name: 'Other health care', value: 'OTHER_HEALTH_CARE' },
  { name: 'Industrial development', value: 'INDUSTRIAL_DEVELOPMENT' },
  { name: 'Pollution control', value: 'POLLUTION_CONTROL' },
  { name: 'Solid waste/res recovery', value: 'SOLID_WASTE_RES_RECOVERY' },
  { name: 'Economic development', value: 'ECONOMIC_DEVELOPMENT' },
  { name: 'Office building/limited partnerships', value: 'OFFICE_BUILDING_LIMITED_PARTNERSHIPS' },
  { name: 'Malls/shopping centers', value: 'MALLS_SHOPPING_CENTERS' },
  { name: 'Secured airlines', value: 'SECURED_AIRLINES' },
  { name: 'Unsecured airlines', value: 'UNSECURED_AIRLINES' },
  { name: 'Other industrial development', value: 'OTHER_INDUSTRIAL_DEVELOPMENT' },
  { name: 'Private human service provider', value: 'PRIVATE_HUMAN_SERVICE_PROVIDER' },
  { name: 'Hotel', value: 'HOTEL' },
  { name: 'Civic/convention centers', value: 'CIVIC_CONVENTION_CENTERS' },
  { name: 'Stadiums/sports complex', value: 'STADIUMS_SPORTS_COMPLEX' },
  { name: 'Theaters', value: 'THEATERS' },
  { name: 'Parks/zoos/beaches', value: 'PARKS_ZOOS_BEACHES' },
  { name: 'Other recreation', value: 'OTHER_RECREATION' },
  { name: 'Airports', value: 'AIRPORTS' },
  { name: 'Seaports/marine terminals', value: 'SEAPORTS_MARINE_TERMINALS' },
  { name: 'Streets/highways', value: 'STREETS_HIGHWAYS' },
  { name: 'Bridges', value: 'BRIDGES' },
  { name: 'Tunnels', value: 'TUNNELS' },
  { name: 'Parking facilities', value: 'PARKING_FACILITIES' },
  { name: 'Mass/rapid transit', value: 'MASS_RAPID_TRANSIT' },
  { name: 'Toll road', value: 'TOLL_ROAD' },
  { name: 'Other transportation', value: 'OTHER_TRANSPORTATION' },
  { name: 'Electric public power', value: 'ELECTRIC_PUBLIC_POWER' },
  { name: 'Water sewer', value: 'WATER_SEWER' },
  { name: 'Gas', value: 'GAS' },
  { name: 'Telephone', value: 'TELEPHONE' },
  { name: 'Sanitation', value: 'SANITATION' },
  { name: 'Flood control/storm drain', value: 'FLOOD_CONTROL_STORM_DRAIN' },
  { name: 'Combined utilities', value: 'COMBINED_UTILITIES' },
  { name: 'Water', value: 'WATER' },
  { name: 'Other utilities', value: 'OTHER_UTILITIES' },
  { name: 'Sewer', value: 'SEWER' },
  { name: 'Cogeneration', value: 'COGENERATION' },
  { name: 'Veterans', value: 'VETERANS' },
  { name: 'Agriculture', value: 'AGRICULTURE' },
  { name: 'Irrigation', value: 'IRRIGATION' },
  { name: 'Other Post Employee Benefits', value: 'OTHER_POST_EMPLOYEE_BENEFITS' },
  { name: 'Pension Obligation', value: 'PENSION_OBLIGATION' }
]